import { theme } from 'antd';
import { DeletedFilled } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSiteByOrgAndSiteID } from 'reduxStore/sites/selectors';
import { sitesActions } from 'reduxStore/sites/slice';
import { Button, Divider, Flex, Modal, Tooltip, Typography } from 'zui/Antd';

const { Title, Text } = Typography;

const DeleteSiteModal = ({ children, siteID, open, setOpen }) => {
	// ✅ Hooks
	const {
		token: { paddingLG, fontSizeSM, marginXL, marginXS, paddingXL, paddingXS, paddingSM }
	} = theme.useToken();
	const dispatch = useDispatch();

	// ✅ Redux state
	const { loadingDelete: loading } = useSelector((state) => state.Sites);

	// ✅ Local state
	const site = useSelector((state) => selectSiteByOrgAndSiteID(state, siteID));

	//Determine if is permitted to delete sites
	const isPermittedDeleteSite = useManagePermittedRoles('deleteSite', {
		101: [site?.orgID],
		103: [site?.siteID]
	});

	// ✅ Close modal
	const handleCancel = () => setOpen(false);

	// ✅ Handle deletion
	const handleDelete = () => {
		dispatch(sitesActions.deleteSite({ siteID }));

		setTimeout(() => {
			handleCancel();
		}, 500);
	};

	return (
		<Fragment>
			<Tooltip title={isPermittedDeleteSite ? 'Delete Site' : "You don't have permission to delete this site"}>
				{children ? (
					children
				) : (
					<Button
						onClick={() => setOpen(true)}
						disabled={!isPermittedDeleteSite || loading}
						danger
						type='primary'
					>
						Delete Site
					</Button>
				)}
			</Tooltip>

			<Modal
				open={open}
				onCancel={handleCancel}
				closeIcon={false}
				centered
				destroyOnClose
				footer={[
					<Flex
						align='center'
						justify='center'
						style={{ marginTop: marginXL, padding: `0px ${paddingXS}px` }}
						gap={12}
						key='footer'
					>
						<Button onClick={handleCancel} type='default' disabled={loading} block>
							Cancel
						</Button>
						<Button onClick={handleDelete} loading={loading} disabled={loading} type='primary' danger block>
							Delete
						</Button>
					</Flex>
				]}
				width={350}
				styles={{ content: { padding: paddingXL } }}
			>
				<Flex vertical align='center' justify='center' gap={paddingSM}>
					<DeletedFilled />
					<Flex vertical gap={paddingLG}>
						<Flex vertical gap={paddingXS} align='center' style={{ margin: `${paddingXS}px 0px` }}>
							<Title
								level={5}
								style={{
									margin: 0,
									lineHeight: '24px',
									textAlign: 'center',
									padding: `0px ${paddingXL}px`
								}}
							>
								Are you sure you want to delete this site?
							</Title>
							<Text
								style={{
									fontSize: fontSizeSM,
									lineHeight: '24px',
									textAlign: 'center',
									display: 'block'
								}}
							>
								This action is permanent and <br /> cannot be undone.
							</Text>
						</Flex>

						<Flex vertical gap={marginXS}>
							<Divider orientation='center' plain style={{ margin: 0, padding: 0, marginTop: 0 }}>
								<Text style={{ fontSize: fontSizeSM, fontWeight: 200 }}>Selected Site</Text>
							</Divider>
							<Text style={{ fontSize: fontSizeSM, fontWeight: 200, textAlign: 'center' }}>
								{site?.name || '-'}
							</Text>
						</Flex>
					</Flex>
				</Flex>
			</Modal>
		</Fragment>
	);
};

export default DeleteSiteModal;
